/* eslint-disable no-undef */
import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2"; // Assurez-vous d'avoir installé SweetAlert2

//** Import Image */
import map from "../../../assets/images/map.png";
import profile from "../../../assets/images/profile/19.jpg";
import profile2 from "../../../assets/images/profile/18.jpg";

function RestaurantOverview() {
  const { nameRes } = useParams();
  const navigate = useNavigate();

  const [restaurant, setRestaurant] = useState(null);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false); // Mode édition
  const [editedFields, setEditedFields] = useState({}); // Champs modifiés
  const [franchiseFK, setFranchiseFK] = useState("");
  const [franchises, setFranchises] = useState([]);


  useEffect(() => {
    const fetchFranchises = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_URL}/franchise`
        );
        setFranchises(response.data.data);
      } catch (error) {
        console.error("Error fetching franchises:", error);
      }
    };

    fetchFranchises();
    const fetchRestaurantData = async () => {
      try {
        const response = await axios.get(
          `${
            import.meta.env.VITE_REACT_APP_BACKEND_URL
          }/restau/retrieve-restaurant/${nameRes}`
        );
        setRestaurant(response.data); // Stocker la réponse dans l'état
      } catch (error) {
        setError("Error while retrieving data: " + error.message);
      }
    };

    if (nameRes) {
      fetchRestaurantData();
    }
  }, []);

  const refreshPage = () => {
    window.location.href="//" + nameRes;
  }

  if (error) {
    return <div>{error} &nbsp; <Link className="btn btn-primary" onClick={refreshPage}>Refresh Page</Link></div>;
  }

  const handleEdit = () => {
    setIsEditing(true); // Activer le mode édition
    setEditedFields({ ...restaurant }); // Copier les champs actuels
  };

  const handleInputChange = (field, value) => {
    setEditedFields((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const saveChanges = async () => {
    try {
      const response = await axios.put(
        `${
          import.meta.env.VITE_REACT_APP_BACKEND_URL
        }/restau/update-restaurant/${nameRes}`,
        editedFields
      );
      setRestaurant(response.data); // Mettre à jour avec les nouvelles données
      setIsEditing(false); // Désactiver le mode édition
      Swal.fire(
        "Success",
        "Restaurant details updated successfully.",
        "success"
      );
      navigate("/restaurants");
    
    } catch (error) {
      setError("Error while saving data: " + error.message);
      console.error("Erreur lors de la soumission:", error);
      const errorMessage = error.response.data.error;

      // Afficher l'alerte spécifique en fonction de l'erreur
      // if (errorMessage.includes("Restaurant with this name already exist")) {
      //   swal("WARNING", "Restaurant with this name already exist", "warning");
      // } else if (
      //   errorMessage.includes("Restaurant with this email already exist")
      // ) {
      //   swal("WARNING", "Restaurant with this email already exist", "warning");
      // } else if (
      //   errorMessage.includes(
      //     "Restaurant with this tax identification number already exist"
      //   )
      // ) {
      //   swal(
      //     "WARNING",
      //     "Restaurant with this tax identification number already exist",
      //     "warning"
      //   );
      // } else {
        swal("WARNING", `Error : ${errorMessage}`, "warning");
      // }
    }
  };

  const archiveRestaurant = async () => {
    // Afficher une boîte de confirmation avec SweetAlert
    Swal.fire({
      title: "Are you sure to archive this restaurant?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dd6b55",
      cancelButtonColor: "#aaa",
      confirmButtonText: "Yes, archive it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.put(
            `${
              import.meta.env.VITE_REACT_APP_BACKEND_URL
            }/restau/archive-restaurant/${nameRes}`
          );
          setRestaurant(response.data.data); // Mettre à jour les données du restaurant
          Swal.fire(
            "Archived!",
            "The restaurant has been archived successfully.",
            "success"
          );
          window.location.href = "//" + nameRes;
        } catch (error) {
          setError("Error while archiving the restaurant: " + error.message);
          Swal.fire(
            "Error!",
            "An error occurred while trying to archive the restaurant.",
            "error"
          );
        }
      }
    });
  };

  const restoreRestaurant = async () => {
    // Afficher une boîte de confirmation avec SweetAlert
    Swal.fire({
      title: "Are you sure to restore this restaurant?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dd6b55",
      cancelButtonColor: "#aaa",
      confirmButtonText: "Yes, restore it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.put(
            `${
              import.meta.env.VITE_REACT_APP_BACKEND_URL
            }/restau/desarchive-restaurant/${nameRes}`
          );
          setRestaurant(response.data.data); // Mettre à jour les données du restaurant
          Swal.fire(
            "Archived!",
            "The restaurant has been restored successfully.",
            "success"
          );
          window.location.href = "//" + nameRes;
        } catch (error) {
          setError("Error while restoring the restaurant: " + error.message);
          Swal.fire(
            "Error!",
            "An error occurred while trying to restore the restaurant.",
            "error"
          );
        }
      }
    });
  };

  return (
    <>
      <div className="d-flex justify-content-end">
        <Dropdown className="dropdown mb-md-4 mb-2 text-end">
          {!restaurant?.archive ? (
            <span className="btn btn-success">
              <svg
                width={22}
                className="me-2"
                height={28}
                viewBox="0 0 22 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.16647 27.9558C9.25682 27.9856 9.34946 28.0001 9.44106 28.0001C9.71269 28.0001 9.97541 27.8732 10.1437 27.6467L21.5954 12.2248C21.7926 11.9594 21.8232 11.6055 21.6746 11.31C21.526 11.0146 21.2236 10.8282 20.893 10.8282H13.1053V0.874999C13.1053 0.495358 12.8606 0.15903 12.4993 0.042327C12.1381 -0.0743215 11.7428 0.0551786 11.5207 0.363124L0.397278 15.7849C0.205106 16.0514 0.178364 16.403 0.327989 16.6954C0.477614 16.9878 0.77845 17.1718 1.10696 17.1718H8.56622V27.125C8.56622 27.5024 8.80816 27.8373 9.16647 27.9558ZM2.81693 15.4218L11.3553 3.58389V11.7032C11.3553 12.1865 11.7471 12.5782 12.2303 12.5782H19.1533L10.3162 24.479V16.2968C10.3162 15.8136 9.92444 15.4218 9.44122 15.4218H2.81693Z"
                  fill="#fff"
                />
              </svg>
              In Work
            </span>
          ) : (
            <span className="btn btn-dark">
              <svg
                width={22}
                className="me-2"
                height={28}
                viewBox="0 0 22 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.16647 27.9558C9.25682 27.9856 9.34946 28.0001 9.44106 28.0001C9.71269 28.0001 9.97541 27.8732 10.1437 27.6467L21.5954 12.2248C21.7926 11.9594 21.8232 11.6055 21.6746 11.31C21.526 11.0146 21.2236 10.8282 20.893 10.8282H13.1053V0.874999C13.1053 0.495358 12.8606 0.15903 12.4993 0.042327C12.1381 -0.0743215 11.7428 0.0551786 11.5207 0.363124L0.397278 15.7849C0.205106 16.0514 0.178364 16.403 0.327989 16.6954C0.477614 16.9878 0.77845 17.1718 1.10696 17.1718H8.56622V27.125C8.56622 27.5024 8.80816 27.8373 9.16647 27.9558ZM2.81693 15.4218L11.3553 3.58389V11.7032C11.3553 12.1865 11.7471 12.5782 12.2303 12.5782H19.1533L10.3162 24.479V16.2968C10.3162 15.8136 9.92444 15.4218 9.44122 15.4218H2.81693Z"
                  fill="#fff"
                />
              </svg>
              Stand By
            </span>
          )}
        </Dropdown>
        &nbsp;
        <Dropdown className="dropdown mb-md-4 mb-2 text-end">
          {!isEditing ? (
            <span
              className="btn "
              style={{ backgroundColor: "#FFC107", color: "#fff" }}
              onClick={handleEdit}
            >
              <svg
                width={22}
                height={28}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.293 2.293a1 1 0 011.414 1.414l-9.12 9.12a1 1 0 01-.475.28l-4.292 1.295a1 1 0 01-1.225-1.225l1.295-4.292a1 1 0 01.28-.475l9.12-9.12a1 1 0 011.414 1.414l-8.707 8.707a1 1 0 00-.235.257l-3.353 3.353a1 1 0 00-.235.257l-.232.695a1 1 0 00.12.885l1.56 1.56a1 1 0 00.885.12l.695-.232a1 1 0 00.257-.235l3.353-3.353 8.707-8.707a1 1 0 011.414-1.414l-9.12 9.12a1 1 0 01-.475.28l-4.292 1.295a1 1 0 01-1.225-1.225l1.295-4.292a1 1 0 01.28-.475l9.12-9.12z"
                  fill="#fff"
                />
              </svg>
              Edit
            </span>
          ) : (
            <span
              className="btn "
              style={{ backgroundColor: "#FFC107", color: "#fff" }}
              onClick={saveChanges}
            >
              <svg
                width={22}
                height={28}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.293 2.293a1 1 0 011.414 1.414l-9.12 9.12a1 1 0 01-.475.28l-4.292 1.295a1 1 0 01-1.225-1.225l1.295-4.292a1 1 0 01.28-.475l9.12-9.12a1 1 0 011.414 1.414l-8.707 8.707a1 1 0 00-.235.257l-3.353 3.353a1 1 0 00-.235.257l-.232.695a1 1 0 00.12.885l1.56 1.56a1 1 0 00.885.12l.695-.232a1 1 0 00.257-.235l3.353-3.353 8.707-8.707a1 1 0 011.414-1.414l-9.12 9.12a1 1 0 01-.475.28l-4.292 1.295a1 1 0 01-1.225-1.225l1.295-4.292a1 1 0 01.28-.475l9.12-9.12z"
                  fill="#fff"
                />
              </svg>
              Save
            </span>
          )}
        </Dropdown>
      </div>

      <div className="row">
        <div className="col-xl-9 col-xxl-8">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="map-bx">
                    <img src={map} alt="map" />
                    {/* <div className="map-content">
                      <h4 className="fs-20 text-black">Track Orders</h4>
                      <span className="fs-12">Lorem ipsum dolor sit</span>
                    </div> */}
                  </div>
                  <h4 className="fs-20 text-black mb-4">Restaurant Info</h4>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="d-flex align-items-center mb-md-0 mb-4">
                        <div>
                          <div className="row">
                            <div className="col-md-6">
                              <label>Name</label>
                              {!isEditing ? (
                                <p style={{ fontSize: 14, width: 500 }}>
                                  {restaurant?.nameRes || "Loading..."}
                                </p>
                              ) : (
                                <input
                                  type="text"
                                  className="form-control"
                                  value={editedFields.nameRes || ""}
                                  onChange={(e) =>
                                    handleInputChange("nameRes", e.target.value)
                                  }
                                />
                              )}
                            </div>
                            <div className="col-md-6">
                              <label>Email</label>
                              {!isEditing ? (
                                <p style={{ fontSize: 14, width: 500 }}>
                                  {restaurant?.owner.email || "Loading..."}
                                </p>
                              ) : (
                                <input
                                  type="email"
                                  className="form-control"
                                  value={editedFields.owner?.email || ""}
                                  onChange={(e) =>
                                    handleInputChange("owner", {
                                      ...editedFields.owner,
                                      email: e.target.value,
                                    })
                                  }
                                />
                              )}
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-md-6">
                              <label>First Name</label>
                              {!isEditing ? (
                                <p style={{ fontSize: 14, width: 500 }}>
                                  {restaurant?.owner.firstName || "Loading..."}
                                </p>
                              ) : (
                                <input
                                  type="text"
                                  className="form-control"
                                  value={editedFields.owner?.firstName || ""}
                                  onChange={(e) =>
                                    handleInputChange("owner", {
                                      ...editedFields.owner,
                                      firstName: e.target.value,
                                    })
                                  }
                                />
                              )}
                            </div>
                            <div className="col-md-6">
                              <label>Last Name</label>
                              {!isEditing ? (
                                <p style={{ fontSize: 14, width: 500 }}>
                                  {restaurant?.owner.lastName || "Loading..."}
                                </p>
                              ) : (
                                <input
                                  type="text"
                                  className="form-control"
                                  value={editedFields.owner?.lastName || ""}
                                  onChange={(e) =>
                                    handleInputChange("owner", {
                                      ...editedFields.owner,
                                      lastName: e.target.value,
                                    })
                                  }
                                />
                              )}
                            </div>
                          </div>

                          <div className="row mt-3">
                            <div className="col-md-12">
                              <label>Franchise</label>
                              {!isEditing ? (
                                <p>
                                  {restaurant?.franchiseFK?.nameFr ||
                                    "Loading..."}
                                </p>
                              ) : (
                                <select
                                  defaultValue={"option"}
                                  id="inputState"
                                  className="form-control"
                                  value={franchiseFK}
                                  onChange={(e) =>
                                    setFranchiseFK(e.target.value)
                                  }
                                >
                                  <option value="">Select Franchise</option>
                                  {franchises.map((franchise) => (
                                    <option
                                      key={franchise._id}
                                      value={franchise._id}
                                      className="custom-option"
                                    >
                                      {franchise.nameFr}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <OrderIdDada /> */}
          </div>
        </div>
        <div className="col-xl-3 col-xxl-4">
          <div className="row">
            <div className="col-xl-12 col-sm-6">
              <div className="card">
                <div className="card-body text-center">
                  <img
                    src={profile}
                    alt="profile"
                    width={130}
                    className="rounded-circle mb-4"
                  />
                  <h3 className="fs-18 text-black font-w600 mb-3">
                    {restaurant
                      ? restaurant.owner.firstName +
                        " " +
                        restaurant.owner.lastName
                      : "Loading..."}
                  </h3>
                  <Link
                    to="#"
                    className="btn btn-primary light btn-sm btn-rounded"
                  >
                    {restaurant ? restaurant.owner.role : "Loading..."}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body bg-light rounded-top ">
          <h3 className="fs-18 text-black font-w600">Danger Zone</h3>
          <p className="fs-14">
            This section is dedicated to the most important actions. Be careful
            with these, as they cannot be undone.
          </p>
        </div>
        <div className=" card-footer d-flex rounded-bottom align-items-center bg-light">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-lg-9 col-md-10">
                  <span className="p-3 me-3 d-inline-block rounded-circle bg-white">
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 3H21V7H3V3Z"
                        stroke="#000000"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10 12H14"
                        stroke="#000000"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M5 7H19V21H5V7Z"
                        stroke="#000000"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className=" font-w600">
                    {restaurant?.archive ? "Restore" : "Archive"} restaurant
                    account
                  </span>
                </div>
                <div className="col-lg-3 col-md-2 mt-2 text-end">
                  {!restaurant?.archive ? (
                    <button
                      className="mx-5 btn btn-danger btn-sm"
                      onClick={archiveRestaurant}
                    >
                      Archive
                    </button>
                  ) : (
                    <button
                      className="mx-5 btn btn-danger btn-sm"
                      onClick={restoreRestaurant}
                    >
                      Restore
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-4"></div>
      </div>
    </>
  );
}

export default RestaurantOverview;
